import React from "react";

const FormField = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  required = false,
  placeholder,
  options,
  rows = 3,
  error,
  // Soft, non-blocking notice (SOUND-777: an out-of-range value already on
  // record). Never shown alongside `error`.
  warning,
  tooltip,
  // select-other props
  otherField,
  otherValue,
  onOtherChange,
}) => {
  const handleChange = (e) => {
    onChange(name, e.target.value);
  };

  const inputClasses = `
    w-full px-4 py-2 rounded-md bg-card border border-border text-foreground placeholder-muted-foreground
    focus:outline-none focus:ring-2 focus:ring-brand transition-colors duration-200
    ${error ? "border-red-500 bg-red-900 bg-opacity-20" : ""}
  `;

  return (
    <div className="mb-4">
      <label className="block mb-1 text-sm font-light text-muted-foreground">
        {label}
        {required && <span className="text-brand ml-1">*</span>}
      </label>
      {tooltip && (
        <p className="text-xs text-muted-foreground/70 mb-1">{tooltip}</p>
      )}

      {type === "textarea" ? (
        <textarea
          name={name}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          rows={rows}
          className={`${inputClasses} resize-none`}
          required={required}
        />
      ) : type === "select" ? (
        <select
          name={name}
          value={value}
          onChange={handleChange}
          className={inputClasses}
          required={required}
        >
          <option value="" className="bg-card text-muted-foreground">
            Select...
          </option>
          {options?.map((option) => (
            <option
              key={option}
              value={option}
              className="bg-card text-foreground"
            >
              {option}
            </option>
          ))}
        </select>
      ) : type === "select-other" ? (
        <div>
          <select
            name={name}
            value={value}
            onChange={handleChange}
            className={inputClasses}
            required={required}
          >
            <option value="" className="bg-card text-muted-foreground">
              Select...
            </option>
            {options?.map((option) => (
              <option
                key={option}
                value={option}
                className="bg-card text-foreground"
              >
                {option}
              </option>
            ))}
          </select>
          {value === "Other" && otherField && (
            <input
              type="text"
              name={otherField}
              value={otherValue || ""}
              onChange={(e) => onOtherChange?.(otherField, e.target.value)}
              placeholder="Please specify..."
              className={`${inputClasses} mt-2`}
            />
          )}
        </div>
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          className={inputClasses}
          required={required}
        />
      )}

      {error && <p className="mt-1 text-sm text-red-400">{error}</p>}
      {!error && warning && <p className="mt-1 text-sm text-warning">{warning}</p>}
    </div>
  );
};

export default FormField;
